export default __webpack_public_path__ + "static/media/100-percent-finished.7806c81d.wav";